module.exports = __webpack_public_path__ + "img/site-natco.219fd019.jpg";